import type { ReactNode } from "react";

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
}

export function EmptyState({ icon, title, description }: EmptyStateProps) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "48px 24px",
        color: "#6b7280",
        textAlign: "center",
      }}
    >
      {icon && (
        <div style={{ marginBottom: 12, opacity: 0.5 }}>{icon}</div>
      )}
      <div style={{ fontSize: 14, fontWeight: 500, color: "#374151" }}>
        {title}
      </div>
      {description && (
        <div style={{ fontSize: 13, marginTop: 4 }}>{description}</div>
      )}
    </div>
  );
}
